// src/pages/therapists/TherapistRatingPage.js
import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore'
import { db } from '../../firebaseConfig'

export default function TherapistRatingPage() {
  const navigate = useNavigate()
  const location = useLocation()

  const [therapists, setTherapists] = useState([])
  const [selectedId, setSelectedId] = useState('')
  const [rating, setRating] = useState('0.00')
  const [, setLoading] = useState(false) // ✅ [PERBAIKAN] Menghapus pemanggilan 'loading' agar tidak muncul warning

  // Ambil ID dari URL jika ada: /therapists/rating?id=xxxxx
  const queryParams = new URLSearchParams(location.search)
  const therapistIdFromUrl = queryParams.get('id') || ''

  // LOAD TERAPIS
  const loadTherapists = async () => {
    setLoading(true)
    const snap = await getDocs(collection(db, 'therapists'))
    const data = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
      rating:
        typeof d.data().rating === 'number'
          ? d.data().rating
          : parseFloat(d.data().rating || 0),
    }))
    setTherapists(data)
    setLoading(false)
  }

  useEffect(() => {
    loadTherapists()
  }, [])

  // ✅ [PERBAIKAN] Dibungkus useCallback dan diletakkan sebelum useEffect
  const selectTherapist = useCallback((id) => {
    setSelectedId(id)
    const therapist = therapists.find((t) => t.id === id)
    setRating(therapist?.rating?.toFixed(2) || '0.00')
  }, [therapists])

  // AUTO SELECT jika dibuka dari tombol list
  useEffect(() => {
    if (therapistIdFromUrl && therapists.length > 0) {
      selectTherapist(therapistIdFromUrl)
      setSelectedId(therapistIdFromUrl)
    }
  }, [therapists, therapistIdFromUrl, selectTherapist]) // ✅ [PERBAIKAN] selectTherapist masuk ke dalam array

  const clampRating = (val) => {
    let n = parseFloat(val)
    if (isNaN(n)) n = 0
    if (n < 0) n = 0
    if (n > 5) n = 5
    return (Math.round(n * 100) / 100).toFixed(2)
  }

  const saveRating = async () => {
    if (!selectedId) return alert('Pilih terapis terlebih dahulu!')
    const therapistRef = doc(db, 'therapists', selectedId)
    await updateDoc(therapistRef, { rating: parseFloat(rating) })
    alert('✅ Rating terapis diperbarui!')
  }

  return (
    <div className="text-gray-300">
      <h2 className="text-2xl font-bold mb-4">⭐ Update Rating Terapis</h2>

      {/* TOMBOL KEMBALI (PERBAIKAN ERROR) */}
      <button
        onClick={() => navigate('/therapists')}
        className="mb-4 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-700"
      >
        ◀ Kembali ke Menu Terapis
      </button>

      {/* PILIH TERAPIS */}
      <div className="bg-gray-900 p-4 rounded-lg border border-gray-800 mb-4">
        <label className="block mb-2 text-gray-300 font-medium">
          Pilih Terapis
        </label>
        <select
          value={selectedId}
          onChange={(e) => selectTherapist(e.target.value)}
          className="w-full p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
        >
          <option value="">-- Pilih Terapis --</option>
          {therapists.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name} {t.id_number ? `(${t.id_number})` : ''}
            </option>
          ))}
        </select>
      </div>

      {/* UPDATE RATING */}
      {selectedId && (
        <div className="bg-gray-900 p-4 rounded-lg border border-gray-800">
          <label className="block text-gray-300 mb-2">Rating</label>
          <div className="flex items-center gap-3">
            <input
              type="number"
              min="0"
              max="5"
              step="0.01"
              value={rating}
              onChange={(e) => setRating(clampRating(e.target.value))}
              className="w-28 p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
            />
            <span className="text-gray-400 text-sm">0.00–5.00</span>
          </div>

          <button
            onClick={saveRating}
            className="mt-4 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
          >
            Simpan Rating
          </button>
        </div>
      )}
    </div>
  )
}
